/**
 * @format
 */

import {
  REMOVE_LIST_VIEWER_FAILURE,
  REMOVE_LIST_VIEWER_OPTIMISTIC,
  REMOVE_LIST_VIEWER_SUCCESS,
} from '../actions';

export default (state, type, payload) => {
  switch (type) {
    case REMOVE_LIST_VIEWER_OPTIMISTIC: {
      const { viewerId, listId } = payload;

      const updatedListMembers = { ...state.listMembers };

      if (updatedListMembers[listId]) {
        updatedListMembers[listId] = { ...updatedListMembers[listId] };
        delete updatedListMembers[listId][viewerId];

        if (Object.keys(updatedListMembers[listId]).length === 0) {
          delete updatedListMembers[listId];
        }
      }
      return {
        ...state,
        listMembers: updatedListMembers,
      };
    }
    case REMOVE_LIST_VIEWER_SUCCESS:
      // Optionally handle success state if needed
      return {
        ...state,
        listViewerLoading: false,
        listViewerError: null,
      };

    case REMOVE_LIST_VIEWER_FAILURE:
      return {
        ...state,
        listViewerLoading: false,
        listViewerError: payload.message,
        // Optionally revert the optimistic update if needed
        listMembers: {
          ...state.listMembers,
          [payload.viewer.id]: payload.viewer, // Re-add the viewer that was removed
        },
      };
    default:
      return state;
  }
};
